var _excluded = ["propertyType", "eer"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useReducer, useRef } from 'react';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { SignInType } from '@domain-group/fe-allhomes-library';
import { FollowedPropertyRelationship, ResponseStatus } from './types/graphql-schema.generated';
import { useFollowThisPropertyMutation } from './graphql/follow-this-property.mutation.generated';
import { simplifyFeatures } from './utils/simplify-features';
import { ERROR_MESSAGE } from './utils/use-modal-control';
import { useFollowedPropertyDialogGetPropertyDetailsLazyQuery } from './graphql/get-property-details.query.generated';
import useAuthQueryParams from './utils/use-auth-query-params';
var globalInstanceCount = 0;
var initialState = {
  state: 'closed',
  show: false
};
var followThisPropertyReducer = log => (state, action) => {
  log.info('reducer: action received', action);
  var signedIn = state.signedIn;
  if (action.action === 'startOpenModal') {
    return {
      state: 'loading-property',
      show: true,
      signedIn
    };
  }
  if (action.action === 'showModal') {
    return {
      state: 'open',
      show: true,
      signedIn,
      targetProperty: action.property,
      selectedRelationship: FollowedPropertyRelationship.OWNER
    };
  }
  if (action.action === 'showError') {
    log.error("Showing error: ".concat(action.error));
    return {
      state: 'error',
      signedIn,
      show: true,
      error: action.error
    };
  }
  if (action.action === 'updateRelationship' && state.state === 'open') {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedRelationship: action.relationship
    });
  }
  if (action.action === 'closeModal') {
    return _objectSpread(_objectSpread({}, initialState), {}, {
      signedIn
    });
  }
  if (action.action === 'updateSignInState') {
    log.info('updating sign in state to', action.signedIn);
    if (state.state === 'waiting-for-sign-in' && action.signedIn) {
      log.info("We were waiting for sign in, and now we're sign in, so go back to the pending state");
      return _objectSpread(_objectSpread({}, state), {}, {
        state: 'follow-property-pending',
        show: true,
        signedIn: action.signedIn
      });
    }
    log.info("There's nothing special happening, we'll update the signed in state and carry on");
    return _objectSpread(_objectSpread({}, state), {}, {
      signedIn: action.signedIn
    });
  }
  if (action.action === 'startFollowingProperty') {
    if (state.state !== 'open') {
      log.warn("attempt to follow property from state ".concat(state, ", ignoring"));
      return state;
    }
    if (state.targetProperty === null || state.selectedRelationship === null) {
      log.error("No target property - this shouldn't happen");
      return {
        state: 'error',
        signedIn,
        show: true,
        error: ERROR_MESSAGE
      };
    }
    var targetProperty = state.targetProperty,
      selectedRelationship = state.selectedRelationship;
    var _simplifyFeatures = simplifyFeatures(state.targetProperty.features),
      propertyType = _simplifyFeatures.propertyType,
      _eer = _simplifyFeatures.eer,
      details = _objectWithoutProperties(_simplifyFeatures, _excluded);
    var input = {
      relationship: selectedRelationship,
      streetAddressId: targetProperty.address.id,
      details: _objectSpread(_objectSpread({}, details), {}, {
        propertyType: propertyType
      })
    };
    return state.signedIn ? {
      state: 'follow-property-pending',
      show: true,
      signedIn,
      input
    } : {
      state: 'waiting-for-sign-in',
      signedIn,
      show: false,
      input
    };
  }
  if (action.action === 'completed') {
    return {
      state: 'follow-property-complete',
      signedIn,
      show: false,
      followedProperty: action.followedProperty
    };
  }
  return state;
};
var useFollowThisProperty = function useFollowThisProperty() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$onCompleted = _ref.onCompleted,
    onCompleted = _ref$onCompleted === void 0 ? () => {} : _ref$onCompleted;
  var renderCount = useRef(0);
  var instanceCount = useRef(++globalInstanceCount);
  var _useAllhomesApi = useAllhomesApi(),
    isSignedIn = _useAllhomesApi.isSignedIn,
    openSignIn = _useAllhomesApi.openSignIn,
    getLogger = _useAllhomesApi.getLogger;
  var log = getLogger("fe-co-allhomes-followed-properties-dialog#useFollowThisProperty#".concat(instanceCount.current));
  var _useAuthQueryParams = useAuthQueryParams(),
    mutationParams = _useAuthQueryParams.mutationParams;
  var _useReducer = useReducer(followThisPropertyReducer(log), _objectSpread(_objectSpread({}, initialState), {}, {
      signedIn: isSignedIn
    })),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  renderCount.current += 1;
  log.info("rendering hook count: ".concat(renderCount.current, ", state: "), {
    state,
    isSignedIn
  });
  useEffect(() => {
    log.warn('mounted');
    return () => {
      log.warn('unmounted');
    };
  }, [log]);
  var _useFollowedPropertyD = useFollowedPropertyDialogGetPropertyDetailsLazyQuery({
      onCompleted: _ref2 => {
        var property = _ref2.property;
        log.info('getPropertyDetails returned', {
          property
        });
        dispatch(property ? {
          action: 'showModal',
          property
        } : {
          action: 'showError',
          error: "Couldn't find that proeprty"
        });
      },
      onError: error => {
        log.error('getPropertyDetails return error', error);
        dispatch({
          action: 'showError',
          error: ERROR_MESSAGE
        });
      }
    }),
    _useFollowedPropertyD2 = _slicedToArray(_useFollowedPropertyD, 2),
    getPropertyDetails = _useFollowedPropertyD2[0],
    queryLoading = _useFollowedPropertyD2[1].loading;
  var _useFollowThisPropert = useFollowThisPropertyMutation(_objectSpread(_objectSpread({}, mutationParams), {}, {
      refetchQueries: 'active'
    })),
    _useFollowThisPropert2 = _slicedToArray(_useFollowThisPropert, 2),
    followThisPropertyMutation = _useFollowThisPropert2[0],
    mutationLoading = _useFollowThisPropert2[1].loading;
  var input = state.state === 'follow-property-pending' ? state.input : null;
  useEffect(() => {
    log.info('useEffect: (followProperty) ', {
      state: state.state
    });
    if (state.state === 'follow-property-pending' && input) {
      log.warn('calling: followThisProperty', input);
      followThisPropertyMutation({
        variables: {
          input
        }
      }).then(_ref3 => {
        var data = _ref3.data;
        log.info('Follow property returned', data);
        if ((data === null || data === void 0 ? void 0 : data.createFollowedProperty.status) !== ResponseStatus.OK || !data.createFollowedProperty.followedProperty) {
          log.warn("Response wasn't OK: ".concat(data === null || data === void 0 ? void 0 : data.createFollowedProperty.status));
          dispatch({
            action: 'showError',
            error: ERROR_MESSAGE
          });
        } else {
          dispatch({
            action: 'completed',
            followedProperty: data.createFollowedProperty.followedProperty
          });
        }
      }).catch(error => {
        log.error('Failed to follow the property:', error);
        dispatch({
          action: 'showError',
          error: ERROR_MESSAGE
        });
      });
    }
  }, [followThisPropertyMutation, log, state.state, input]);
  var followedProperty = 'followedProperty' in state ? state.followedProperty : null;
  useEffect(() => {
    log.info('useEffect: (completed)', {
      state: state.state,
      followedProperty
    });
    if (state.state === 'follow-property-complete' && followedProperty) {
      log.info('All done, calling onComplete');
      onCompleted({
        action: 'follow',
        followedProperty
      });
      log.info('All done, resetting');
      dispatch({
        action: 'closeModal'
      });
    }
  }, [log, state.state, followedProperty, onCompleted]);
  useEffect(() => {
    log.info('useEffect (signing in)', {
      state: state.state,
      signedIn: state.signedIn
    });
    if (state.state === 'waiting-for-sign-in' && !state.signedIn) {
      log.warn('Opening sign in');
      openSignIn(SignInType.MY_ALLHOMES).then(result => {
        log.info('Sign in result:', result);
        if (!result) {
          log.info("Closed the sign in, so we'll cancel the whole thing");
          dispatch({
            action: 'closeModal'
          });
        }
        log.info('leaving promise handler');
      });
      log.info('Open sign in triggered, leaving useEffect()');
    }
  }, [log, state.state, state.signedIn, openSignIn]);
  useEffect(() => {
    log.info('useEffect (sign in status)', {
      isSignedIn,
      stateSignedIn: state.signedIn
    });
    if (state.signedIn !== isSignedIn) {
      log.info('State differs, so updating signed in state');
      dispatch({
        action: 'updateSignInState',
        signedIn: isSignedIn
      });
    }
  }, [isSignedIn, log, state.signedIn]);
  var handleFollowThisProperty = addressId => {
    log.info('handleFollowThisProperty, requesting address details', {
      addressId
    });
    getPropertyDetails({
      variables: {
        addressId
      }
    });
    dispatch({
      action: 'startOpenModal'
    });
  };
  var handleRelationshipChange = relationship => {
    log.info('handleRelationshipChange', {
      relationship
    });
    dispatch({
      action: 'updateRelationship',
      relationship
    });
  };
  var handleClose = () => {
    log.info('handleClose');
    dispatch({
      action: 'closeModal'
    });
  };
  var handleSubmit = () => {
    log.info('handleSubmit');
    dispatch({
      action: 'startFollowingProperty'
    });
  };
  var followThisPropertyProps = state.show ? {
    show: state.show,
    error: state.state === 'error' ? state.error : undefined,
    onClose: handleClose,
    onSubmit: handleSubmit,
    loading: queryLoading || mutationLoading || state.state === 'loading-property',
    property: 'targetProperty' in state ? state.targetProperty : null,
    selectedRelationship: 'selectedRelationship' in state ? state.selectedRelationship : FollowedPropertyRelationship.OWNER,
    onRelationshipChange: handleRelationshipChange
  } : null;
  log.info('followThisPropertyProps: ', followThisPropertyProps);
  return {
    openFollowThisProperty: handleFollowThisProperty,
    followThisPropertyProps
  };
};
export default useFollowThisProperty;